export interface AriaType {
  /** errormessage */
  'aria-errormessage'?: string;
  /** describedby */
  'aria-describedby'?: string;
}

/**
 * Utility  function for validation messages and helper texts.
 */
export default (
  errorWarningText?: string,
  helperText?: string,
  errorWarningTextId?: string,
  helperTextId?: string
) => {
  const ariaIds = [];
  const aria: AriaType = {};

  if (errorWarningText) {
    ariaIds.push(errorWarningTextId);
    aria['aria-errormessage'] = errorWarningTextId;
  }

  if (helperText) {
    ariaIds.push(helperTextId);
  }

  if (ariaIds.length) {
    aria['aria-describedby'] = ariaIds.join(' ');
  }

  return aria;
};
